import { Record } from 'immutable';


export const SelectedBaselineJobInfo = new Record({
  url: null,
  timestamp: null,
  metrics: {},
});
